import Axios from 'axios';
import { openReport } from '../../../utils/sessionGuard'; // セッション失効時は新タブを開かず現在の画面でログインへ
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import config from '../../Config/key';
import { DEFAULT_BCC_EMAIL } from '../../Config/mailConfig';
// ページ外郭コンテナ（デザインシステム Ph.4: width:90% → max-width 1240px へ統一）
// テーブル強化 PJ Ph.3: メイン一覧テーブルに 列リサイズ + ソート + 省略
// （発行チケット確認モーダルのトークン一覧テーブルも同処理を適用済み）
import {
  PageContainer,
  StatusBadge,
  useResizableColumns,
  ellipsisColumn,
  textSorter,
  numberSorter,
} from '../../common';
import {
  Table,
  Button,
  message,
  Typography,
  Select,
  Modal,
  Space,
  Spin,
  Input,
  Pagination,
} from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { userRole } from '../../Config/userRole';
import UserFormModal from './UserFormModal';
import InactiveBadge from './InactiveBadge';
import { useSelector } from 'react-redux';
import { filterAccessibleSeasons } from '../../../utils/seasonFilter';
// 初期パスワードの自動生成（新規登録モーダルと共用。規則はサーバーと同一）
import { generateInitialPassword } from '../../../utils/initialPassword';
import { BsBoxArrowUpRight } from 'react-icons/bs';
import { surveyCode } from '../../Config/surveyCode';
import { surveyStatus } from '../../Config/surveyStatus';
const ExcelJS = require('exceljs');
const { Text } = Typography;
const { Option } = Select;
const { confirm } = Modal;
const survey_status_complete = 5;
// 「実施有無：未回答」の対象ステータス（実施前・一時保存中・期限切れ）
const UNANSWERED_STATUSES = [0, 1, 7];

// 権限付与 Select の選択肢（ユーザー単件編集 PJ Ph.2 で 3 ボタン → Select 1 個に集約）
// 一覧から変更できるのは 受講者 / シーズン管理者 / 企業管理者 の 3 種のみ
const ROLE_SELECT_OPTIONS = [
  { value: 1, label: '受講者' },
  { value: 7, label: 'シーズン管理者' },
  { value: 3, label: '企業管理者' },
];
const ROLE_SELECTABLE = ROLE_SELECT_OPTIONS.map((option) => option.value);

/**
 * 一覧表示用の派生項目（氏名・権限ラベル・チケット集計）をユーザーに付与する
 * ※ 一覧取得時（filterDatasource）と編集モーダルの保存後（handleUserSaved）で共用する
 */
const decorateUser = (user) => {
  user.fullName = user.lastname + ' ' + user.name;
  user.roleText = userRole[user.role];
  if (!user.survey_token || user.survey_token.length === 0) {
    user.takeTokenCnt = 0;
    user.usedTokenCnt = 0;
    user.surveyProgress = 0;
  } else {
    user.takeTokenCnt = user.survey_token.length;
    user.usedTokenCnt = user.survey_token.filter(function (tokenInfo) {
      return tokenInfo.survey_status === 5; //実施済み：5
    }).length;
    user.surveyProgress = (user.usedTokenCnt / user.takeTokenCnt) * 100;
  }
  return user;
};

function RespondentMgrPage() {
  const [viewModal, setViewModal] = useState(false);
  // 回答差戻しモーダル（通知メール送付の要否 + CC/BCC を選ぶ2段階フロー）
  const [revertModalOpen, setRevertModalOpen] = useState(false);
  const [revertConfirmOpen, setRevertConfirmOpen] = useState(false);
  const [revertTarget, setRevertTarget] = useState(null); // 差戻し対象トークン(user_name/email 付き)
  const [revertCc, setRevertCc] = useState('');
  const [revertBcc, setRevertBcc] = useState(DEFAULT_BCC_EMAIL); // 既定アドレスを初期表示（画面上で削除・変更可）
  const [revertNotify, setRevertNotify] = useState(false); // 2段階目で確定する「通知するか」
  const [revertSubmitting, setRevertSubmitting] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [userToken, setUserToken] = useState([]);
  const [isAnswerd, setIsAnswerd] = useState(9);
  // const [usedToken, setUsedToken] = useState([]);
  // const [Users, setUsers] = useState([]); //全てのユーザ一覧
  const [tUsers, setTUsers] = useState([]); //グループフィルタリングされたユーザ一覧（全体）
  const [gUsers, setGUsers] = useState([]); //グループ・サーベイシーズンでフィルタリングされたユーザ一覧
  const [groups, setGroups] = useState([]); //グループ名とグループコード
  const [selGroupInfo, setSelGroupInfo] = useState([]); //グループ名とグループコード
  const [surveySeason, setSurveySeason] = useState([]);
  const [selSurveySeason, setSelSurveySeason] = useState([]);
  const [selGroupCode, setSelGroupCode] = useState(''); //選択されたグルプコード
  const [survey, setSurvey] = useState([]); //サーベイ名とサーベイコード
  const [questionSetFilter, setQuestionSetFilter] = useState([]); //全ての設問セット
  // const [selQuestionSetFilter, setSelQuestionSetFilter] = useState([]); //全ての設問セット
  const [questionSet, setQuestionSet] = useState([]); //全ての設問セット
  const [selSurveyId, setSelSurveyId] = useState(''); //選択したサーベイID
  // const [role360, setRole360] = useState(1); //選択した360度関係：１：本人、２：上司、３：部下・同僚
  const [selSurveySeasonId, setSelSurveySeasonId] = useState(''); //選択したサーベイID
  const [selSurveySeasonIdFilter, setSelSurveySeasonIdFilter] = useState(''); //選択したサーベイID
  const [selQuestionSetId, setSelQuestionSetId] = useState(''); //選択した設問セットID
  const [selTicketSurveyCode, setSelTicketSurveyCode] = useState(''); //チケット発行用で選択したサーベイの種類
  const [selQuestionSetFilterId, setSelQuestionSetFilterId] = useState(''); //選択した設問セットID
  const [rowKeys, setRowKeys] = useState({
    //選択されたユーザ一覧
    selectedRowKeys: [], // Check here to configure the default column
    loading: false,
  });
  // 詳細検索パネルの表示状態
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  // 詳細検索の条件
  const [searchName, setSearchName] = useState('');
  const [searchEmail, setSearchEmail] = useState('');
  const [searchRoles, setSearchRoles] = useState([]);
  // ユーザー情報の登録・編集モーダル（role 9 のみ。新規登録・編集で同一モーダルを使う）
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [userModalMode, setUserModalMode] = useState('edit'); //'edit' = 情報編集 / 'create' = 新規登録
  const [editUser, setEditUser] = useState(null); //編集対象の最新ユーザー文書
  const [orgTree, setOrgTree] = useState(null); //組織表（確定バージョン）: { version, units } | null
  const [orgTreeGroupCode, setOrgTreeGroupCode] = useState(''); //orgTree を取得済みの企業コード
  //一覧のページング状態（ページネーションを Table 外へ出して制御するため）
  const [pageInfo, setPageInfo] = useState({ current: 1, pageSize: 100 });

  const usr = useSelector((state) => state.user);
  //9:管理者９が最高管理者
  // const userRole = [
  //   '停止中',
  //   '学習者',
  //   '管理者',
  //   'その他',
  //   'その他',
  //   'その他',
  //   'その他',
  //   'その他',
  //   'その他',
  //   '最高管理者',
  // ];

  const readDB = async () => {
    try {
      if (!usr.userData) return null;
      // console.log(usr.userData);

      const [surveyInfo, groupInfo, seasonInfo] = await Promise.all([
        Axios.get('/api/survey/'), //DBからサーベイ情報取得
        Axios.get('/api/group/'), //DBからグループ情報取得
        Axios.get('/api/surveySeason/'), //DBからシーズン情報取得
        // Axios.get(config.USER_SERVER), //全てのユーザの習得（管理者以外）
      ]);
      if (usr.userData.groupCode === 'RECRNT' && usr.userData.role === 2) {
        const nonGroup = groupInfo.data.groups.filter(
          (item) => item.group_code !== 'RECRNT'
        );
        setGroups(nonGroup);
      } else {
        setGroups(groupInfo.data.groups);
      }
      setSurvey(surveyInfo.data.survey);
      setSurveySeason(seasonInfo.data.surveySeason);
      setGUsers([]);
      setTUsers([]);
      if (!groups) throw 'グループ取得に失敗しました。';
      if (!survey) throw 'サーベイ取得に失敗しました。';
      if (!seasonInfo) throw 'サーベイシーズン取得に失敗しました。';
      // let userData = res.data;
      // if (!userData) throw 'ユーザー取得に失敗しました。';
      // console.log({ groups });
      // console.log({ survey });
      // console.log({ userData });
      // await userData.map((user) => {
      //   user.fullName = user.lastname + ' ' + user.name;
      //   user.roleText = userRole[user.role];
      //   if (user.survey_token.length === 0) {
      //     user.takeTokenCnt = 0;
      //     user.usedTokenCnt = 0;
      //     user.surveyProgress = 0;
      //   } else {
      //     user.takeTokenCnt = user.survey_token.length;
      //     user.usedTokenCnt = user.survey_token.filter(function (tokenInfo) {
      //       return tokenInfo.survey_status === 5; //実施済み：5
      //     }).length;
      //     user.surveyProgress = (user.usedTokenCnt / user.takeTokenCnt) * 100;
      //   }
      //   return user;
      // });
      // console.log({ userData });
      // setUsers(userData);
      // setGUsers(userData); //全体ユーザ情報を初期表示のためグループフィルターユーザーに格納
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
    // console.log({ Users });
  }, [usr]);

  // 詳細検索条件をgUsersに適用した表示用リスト
  // 名前・メールは部分一致（大文字小文字無視）、権限は選択値のいずれか一致
  const displayUsers = useMemo(() => {
    const nameKw = searchName.trim().toLowerCase();
    const emailKw = searchEmail.trim().toLowerCase();
    return gUsers.filter((u) => {
      if (!u) return false;
      if (nameKw) {
        const target = (u.fullName || '').toLowerCase();
        if (!target.includes(nameKw)) return false;
      }
      if (emailKw) {
        const target = (u.email || '').toLowerCase();
        if (!target.includes(emailKw)) return false;
      }
      if (searchRoles.length > 0) {
        if (!searchRoles.includes(u.role)) return false;
      }
      return true;
    });
  }, [gUsers, searchName, searchEmail, searchRoles]);

  // 現在ページ分だけを切り出したリスト（Table の dataSource 専用）
  // ※ CSVダウンロード・対象者数・チケット発行などは従来どおり displayUsers（全件）を使う
  const pagedUsers = useMemo(() => {
    const start = (pageInfo.current - 1) * pageInfo.pageSize;
    return displayUsers.slice(start, start + pageInfo.pageSize);
  }, [displayUsers, pageInfo]);

  // 絞り込みなどで件数が減り、現在ページが範囲外になったら1ページ目へ戻す
  useEffect(() => {
    const maxPage = Math.max(
      1,
      Math.ceil(displayUsers.length / pageInfo.pageSize)
    );
    if (pageInfo.current > maxPage) {
      setPageInfo((prev) => ({ ...prev, current: 1 }));
    }
  }, [displayUsers, pageInfo]);

  // 表示から外れた選択行は自動で選択解除する
  useEffect(() => {
    setRowKeys((prev) => {
      const visibleIds = new Set(displayUsers.map((u) => u._id));
      const next = prev.selectedRowKeys.filter((id) => visibleIds.has(id));
      if (next.length === prev.selectedRowKeys.length) return prev;
      return { ...prev, selectedRowKeys: next };
    });
  }, [displayUsers]);

  // 詳細検索の条件が一つでも有効か
  const hasActiveSearch =
    searchName.trim() !== '' ||
    searchEmail.trim() !== '' ||
    searchRoles.length > 0;

  // 詳細検索条件のクリア
  const clearAdvancedSearch = () => {
    setSearchName('');
    setSearchEmail('');
    setSearchRoles([]);
  };

  // シーズン管理者（role 7）から別の権限へ変える前に、消える閲覧範囲の件数を最新のユーザー情報から数える
  // （「部署指定拡張」PJ Ph.3。サーバーが role 7 → 7 以外の更新で e3_department・accessible_survey_seasons を空にする）
  const fetchRole7ScopeCounts = async (userId) => {
    const res = await Axios.get(`${config.USER_SERVER}/${userId}`);
    const u = (res.data && res.data.user) || {};
    return {
      e3: (Array.isArray(u.e3_department) ? u.e3_department : []).filter(
        (p) => typeof p === 'string' && p.trim() !== ''
      ).length,
      seasons: Array.isArray(u.accessible_survey_seasons)
        ? u.accessible_survey_seasons.length
        : 0,
    };
  };

  // role 7 → 7 以外の確認モーダルの設定。閲覧範囲が残っていれば削除される旨を表示し、安全側（いいえ）を primary にする
  const prepareRoleChangeConfirm = async (userId, role, currentRole) => {
    if (currentRole !== 7 || role === 7) return {};
    const scope = await fetchRole7ScopeCounts(userId);
    if (scope.e3 === 0 && scope.seasons === 0) return {};
    return {
      content: (
        <div>
          <Text type="danger">
            この操作で、閲覧範囲（部署指定 {scope.e3} 件）・閲覧可能シーズン（{scope.seasons} 件）は削除されます。
          </Text>
          <br />
          <Text type="secondary">
            元に戻すには、シーズン管理者に戻したうえで「閲覧範囲」画面から再設定してください。
          </Text>
        </div>
      ),
      okButtonProps: { type: 'default' },
      cancelButtonProps: { type: 'primary' },
    };
  };

  // 権限変更の結果を一覧の行へ反映する（閲覧範囲を空にした場合はその値も空にする）
  const applyRoleResult = (userId, role, cleared) => {
    const updater = (u) =>
      u._id === userId
        ? {
            ...u,
            role,
            roleText: userRole[role],
            ...(cleared ? { e3_department: [], accessible_survey_seasons: [] } : {}),
          }
        : u;
    setGUsers((prev) => prev.map(updater));
    setTUsers((prev) => prev.map(updater));
  };

  const roleChangeErrorText = (error, base) => {
    const serverError =
      error && error.response && error.response.data && error.response.data.error;
    return serverError ? `${base}${serverError}` : base;
  };

  // 権限変更（一覧の Select / 復元ボタンから呼ばれる。e はボタン経由のときのみ渡される）
  const roleChangeHandler = async (userId, role, currentRole, e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    let scopeConfirm = {};
    try {
      scopeConfirm = await prepareRoleChangeConfirm(userId, role, currentRole);
    } catch (error) {
      message.error('ユーザー情報を取得できませんでした。もう一度お試しください。');
      console.log(error);
      return;
    }
    const isRestore = currentRole === 0;
    const title =
      role === 3
        ? '企業管理者権限に変更しますか？'
        : role === 7
        ? 'シーズン管理者権限に変更しますか？\n（閲覧可能シーズンは「閲覧範囲」画面で指定してください）'
        : isRestore
        ? 'ユーザーを復元しますか？'
        : '受講者権限に変更しますか？';
    Modal.confirm({
      title,
      okText: 'はい',
      cancelText: 'いいえ',
      ...scopeConfirm,
      async onOk() {
        try {
          const res = await Axios.patch(`${config.USER_SERVER}/${userId}/role`, {
            role: role,
          });
          if (res.data.success) {
            // ローカルstateを更新し画面データを維持する
            applyRoleResult(userId, role, res.data.cleared);
            message.success('権限を変更しました。');
          }
        } catch (error) {
          alert(roleChangeErrorText(error, '権限変更に失敗しました。'));
          console.log(error);
        }
      },
    });
  };

  // 組織表（確定バージョン）の取得。企業コード単位でキャッシュする
  // version が null なら確定済みの組織表が無い企業＝所属は企業マスターから選択する
  const loadOrgTree = async (groupCode) => {
    if (!groupCode) return null;
    if (orgTreeGroupCode === groupCode) return orgTree;
    try {
      const res = await Axios.get(`/api/org/tree/${groupCode}`);
      const tree =
        res.data && res.data.success
          ? { version: res.data.version || null, units: res.data.units || [] }
          : null;
      setOrgTree(tree);
      setOrgTreeGroupCode(groupCode);
      return tree;
    } catch (error) {
      // 取得失敗時は「組織表なし」として扱い、編集自体はブロックしない
      console.log({ error });
      setOrgTree(null);
      setOrgTreeGroupCode(groupCode);
      return null;
    }
  };

  // 「情報編集」: 最新のユーザー文書と組織表を取得してからモーダルを開く
  const openEditModal = async (record) => {
    message.loading({
      content: '読み込み中...',
      key: 'useredit',
      duration: 20,
    });
    try {
      const [userRes] = await Promise.all([
        Axios.get(`${config.USER_SERVER}/${record._id}`),
        loadOrgTree(record.group_code || selGroupCode),
      ]);
      if (userRes.data && userRes.data.success && userRes.data.user) {
        setEditUser(userRes.data.user);
        setUserModalMode('edit');
        setUserModalOpen(true);
        message.destroy('useredit');
      } else {
        message.error({
          content: 'ユーザー情報の取得に失敗しました。',
          key: 'useredit',
          duration: 3,
        });
      }
    } catch (error) {
      console.log({ error });
      message.error({
        content: 'ユーザー情報の取得に失敗しました。',
        key: 'useredit',
        duration: 3,
      });
    }
  };

  // 「＋ User」: 選択中の企業に新規ユーザーを登録する（role 9 限定）
  // 所属の入力方式を決めるため、先に組織表（確定バージョン）を取得しておく
  const openCreateModal = async () => {
    if (!selGroupCode) return;
    await loadOrgTree(selGroupCode);
    setEditUser(null);
    setUserModalMode('create');
    setUserModalOpen(true);
  };

  // モーダルの保存完了: 再読み込みせずローカル state のみ更新する
  // meta.created が true のとき（新規登録）は一覧の先頭へ追加する
  const handleUserSaved = (savedUser, meta) => {
    if (savedUser && meta && meta.created) {
      // 選択中の企業と同一グループのときだけ一覧へ反映する
      if (selGroupCode === savedUser.group_code) {
        const decorated = decorateUser({ ...savedUser });
        setGUsers((prev) => [decorated, ...prev]);
        setTUsers((prev) => [decorated, ...prev]);
      }
    } else if (savedUser) {
      const decorated = decorateUser({ ...savedUser });
      const updater = (u) =>
        u._id === decorated._id ? { ...u, ...decorated } : u;
      setGUsers((prev) => prev.map(updater));
      setTUsers((prev) => prev.map(updater));
    }
    setUserModalOpen(false);
    setEditUser(null);
  };

  const closeUserModal = () => {
    setUserModalOpen(false);
    setEditUser(null);
  };

  //ユーザー削除を「role:0」設定（シーズン管理者の場合は閲覧範囲も空になる＝「部署指定拡張」PJ Ph.3）
  const userDeleteHandler = async (userId, currentRole, e) => {
    e.preventDefault();
    let scopeConfirm = {};
    try {
      scopeConfirm = await prepareRoleChangeConfirm(userId, 0, currentRole);
    } catch (error) {
      message.error('ユーザー情報を取得できませんでした。もう一度お試しください。');
      console.log(error);
      return;
    }
    Modal.confirm({
      title: 'ユーザーを停止しますか？',
      okText: 'はい',
      cancelText: 'いいえ',
      ...scopeConfirm,
      content: scopeConfirm.content ? (
        <div>
          <Text>このユーザーを停止状態にします。</Text>
          <br />
          {scopeConfirm.content}
        </div>
      ) : (
        'このユーザーを停止状態にします。'
      ),
      async onOk() {
        try {
          const res = await Axios.patch(`${config.USER_SERVER}/${userId}/role`, {
            role: 0,
          });
          if (res.data.success) {
            // ローカルstateを更新し画面データを維持する
            applyRoleResult(userId, 0, res.data.cleared);
            message.success('論理削除しました。');
          }
        } catch (error) {
          alert(roleChangeErrorText(error, '論理削除に失敗しました。'));
          console.log(error);
        }
      },
    });
  };

  const sendMailHandler = async (data) => {
    let mailList = {};
    try {
      // console.log({ rowKeys });
      // const selMtInfo = mtInfo.find((item) => item._id === selMtId);
      const res = await Axios.get(`/api/mailTemplate/tempw`);
      const selMtInfo = res.data.mailTemplate;
      // console.log({ selMtInfo });
      // console.log({ data });
      mailList = {
        personalizations: [
          {
            to: [
              {
                email: data.user.email,
                name: `${data.user.lastname} ${data.user.name}様`,
              },
            ],
            bcc: { email: 'admin365@re-current.co.jp' },
            substitutions: {
              email: data.user.email,
              fullname: `${data.user.lastname} ${data.user.name}`,
              familyname: data.user.lastname,
              company: data.user.company,
              temp_pw: data.password,
            },
          },
        ],
        from: {
          email: selMtInfo.from_mail, // 送信元アドレス
          name: selMtInfo.from_name, // 送信者名
        },
        subject: selMtInfo.subject,
        html: selMtInfo.body.replace(/\r?\n/g, '<br>'),
        substitutionWrappers: ['{$', '$}'],
        headers: {
          'X-Sent-Using': 'SendGrid-API',
        },
      };
      // console.log({ mailList });
      // const sendMailResult = { data: { success: false } };
      const sendMailResult = await Axios.post('/api/sendMail', {
        mailList: mailList,
        operation_log: 'ManagerResetPasswordSendMail',
      });
      if (sendMailResult.data.success) {
        message.success({
          content: 'メール送信完了！',
          key: 'mail',
          duration: 2,
        });
        return sendMailResult;
      } else {
        message.error({
          content: 'メール送信に失敗しました。',
          key: 'mail',
          duration: 2,
        });
        console.log({ sendMailResult });
        throw new Error('メール送信に失敗しました。');
      }
    } catch (error) {
      console.log(error);
      message.error({
        content: 'メール配信で問題が発生しました。',
        key: 'mail',
        duration: 2,
      });
    }
  };

  const passworChangedHandler = async (user, e) => {
    e.preventDefault();
    Modal.confirm({
      title: 'パスワードを初期化しますか？',
      content: '臨時パスワードを生成し、メールで送信します。',
      okText: 'はい',
      cancelText: 'いいえ',
      async onOk() {
        try {
          const pw = generateInitialPassword();
          const data = {
            user: user,
            password: pw,
            changePassword: false,
          };
          const res = await Axios.patch(`${config.USER_SERVER}/pc`, data);
          if (res.data.success) {
            sendMailHandler(data);
            message.success(
              'パスワードを初期化しました。（臨時パスワードはメールで配信）'
            );
          }
        } catch (error) {
          alert('パスワードを初期化に失敗しました。');
          console.log(error);
        }
      },
    });
  };

  // console.log({ rowKeys });
  const { loading, selectedRowKeys } = rowKeys;

  const hasSelected = selectedRowKeys.length > 0;

  const onSelectChange = async (selectedRowKeys) => {
    // console.log('selectedRowKeys changed: ', selectedRowKeys);
    setRowKeys({ selectedRowKeys });
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  //リストフィルタリング
  const filterDatasource = async (groupCode) => {
    // setGUsers(
    //   Users.filter(function (user) {
    //     return user.group_code === groupCode;
    //   })
    // );
    message.loading({
      content: '読み込み中...',
      key: 'updateable',
      duration: 20,
    });
    const res = await Axios.get(`${config.USER_SERVER}/group/${groupCode}`);
    // console.log({ res });
    let userData = res.data.users;
    userData.forEach((user) => decorateUser(user));
    // console.log({ userData });
    setGUsers(userData);
    setTUsers(userData);
    message.success({
      content: '読み込み完了！',
      key: 'updateable',
      duration: 2,
    });
  };

  //グループを変更した場合
  const onChangeGroup = async (value) => {
    // console.log(`selected ${value}`);
    setSelGroupCode(value);
    filterDatasource(value); //リストフィルタリング
    const selGroup = groups.find((item) => item.group_code === value);
    // console.log({ selGroup });
    setSelGroupInfo(selGroup);
    setQuestionSet([]);
    setSelSurveySeason([]);
    setSelSurveyId('');
    setSelSurveySeasonId('');
    setSelSurveySeasonIdFilter('');
    // setRole360('');
    setSelQuestionSetFilterId('');
    setQuestionSetFilter([]);
    setIsAnswerd(9);
    // setSelSurveySeasonInfo([]);
  };

  //設問セットを変更した場合
  const onChangeQuestionSet = (value) => {
    // console.log(`selected ${value}`);
    setSelQuestionSetId(value); //選択した設問セットIDを格納
  };

  //設問セットを変更した場合
  const onChangeQuestionFilter = (value) => {
    setSelQuestionSetFilterId(value); //選択した設問セットIDを格納
    // const selQuestionSet = questionSetFilter.find((item) => item._id === value);
    // setSelQuestionSetFilter(selQuestionSet); //現在選択したQuestionSet
    // console.log({ questionSetFilter });

    setIsAnswerd(9);
    // console.log({ gUsers });
    const gUserArr = [];
    for (let i = 0; i < tUsers.length; i++) {
      const element = tUsers[i];
      let token = {};
      if (element.survey_token) {
        // if (isAnswerd === 9) {
        token = element.survey_token.find(
          (item) =>
            item.question_set_id === value &&
            item.survey_season_id === selSurveySeasonIdFilter
        );
      }
      if (token) {
        gUserArr.push(element);
      }
    }
    // console.log({ gUserArr });
    setGUsers(gUserArr);
  };

  //実施有無
  const onChangeAnswer = (value) => {
    // console.log({ value });
    setIsAnswerd(value);
    const gUserArr = [];
    for (let i = 0; i < tUsers.length; i++) {
      const element = tUsers[i];
      let token = {};
      if (element.survey_token) {
        if (value === 9) {
          if (selQuestionSetFilterId) {
            token = element.survey_token.find(
              (item) =>
                item.question_set_id === selQuestionSetFilterId &&
                item.survey_season_id === selSurveySeasonIdFilter
            );
          } else {
            token = element.survey_token.find(
              (item) => item.survey_season_id === selSurveySeasonIdFilter
            );
          }
        } else if (value === 5) {
          if (selQuestionSetFilterId) {
            token = element.survey_token.find(
              (item) =>
                item.question_set_id === selQuestionSetFilterId &&
                item.survey_season_id === selSurveySeasonIdFilter &&
                item.survey_status === value
            );
          } else {
            token = element.survey_token.find(
              (item) =>
                item.survey_season_id === selSurveySeasonIdFilter &&
                item.survey_status === value
            );
          }
        } else {
          // 未回答 = 選択シーズン内の 実施前(0)・一時保存中(1)・期限切れ(7)。
          // ※ 以前は「|| survey_status === 7」がシーズン条件の外にあり、他シーズン（過去年度等）に
          //   期限切れトークンを持つだけのユーザーまで未回答に含まれていた。
          //   また設問セット指定時は 7 を含まず、一時保存中(1)はどちらでも漏れていた。
          token = element.survey_token.find(
            (item) =>
              item.survey_season_id === selSurveySeasonIdFilter &&
              (!selQuestionSetFilterId ||
                item.question_set_id === selQuestionSetFilterId) &&
              UNANSWERED_STATUSES.includes(item.survey_status)
          );
        }
      }
      if (token) {
        gUserArr.push(element);
      }
    }
    // console.log({ gUserArr });
    setGUsers(gUserArr);
  };

  //サーベイシーズンを変更した場合（チケット発行）
  const onChangeSeason = async (value) => {
    // console.log(`selected ${value}`);
    // console.log(`selected ${value}`);
    // console.log({ selGroupInfo });
    // console.log({ surveySeason });
    setSelSurveySeasonId(value);
    // filterDatasource(value); //リストフィルタリング
    const selSeasonInfo = selGroupInfo.survey_season.find(
      (item) => item._id === value
    );
    // console.log({ selSeasonInfo });
    setSelTicketSurveyCode(selSeasonInfo.survey_code);
    // setSelSurveySeasonInfo(selSeasonInfo);
    // onChangeSurvey(selSeasonInfo.survey_id);
    const arrQuestionSet = selSeasonInfo.question_set;
    setSelSurveyId(selSeasonInfo.survey_id);
    setQuestionSet(arrQuestionSet);
    // console.log(survey.find((element) => element._id === value).question_set);
    // console.log({ arrQuestionSet });
    //選択したサーベイの設問セットが存在する場合筆頭のセットをデフォルトに選択したセットに設定する
    if (arrQuestionSet.length > 0) {
      setSelQuestionSetId(arrQuestionSet[0]._id);
    } else {
      setSelQuestionSetId('');
    }
  };
  //サーベイシーズンを変更した場合（絞り込み）
  const onChangeSeasonFilter = async (value) => {
    // console.log(`selected ${value}`);
    setIsAnswerd(9);
    setSelSurveySeasonIdFilter(value);
    setSelQuestionSetFilterId('');
    setQuestionSetFilter([]);
    // setRole360(1);
    const selSeasonInfo = selGroupInfo.survey_season.find(
      (item) => item._id === value
    );

    setSelSurveySeason(selSeasonInfo);
    const arrQuestionSet = selSeasonInfo.question_set;
    // setSelSurveyId(selSeasonInfo.survey_id);
    setQuestionSetFilter(arrQuestionSet);
    // const userIdArr = [];
    // const bossArr = [];
    // const partnerArr = [];
    const gUserArr = [];
    if (selSeasonInfo.survey_code === '40010') {
      //360度診断の場合
      // console.log({ selSeasonInfo });
      selSeasonInfo.relation_360.map((element) => {
        // userIdArr.push(element.user_id);
        // bossArr.push(element.boss);
        // partnerArr.push(element.partner);
        gUserArr.push(tUsers.find((item) => item._id === element.user_id)); //本人のみをFilter
        // console.log({ gUserArr });
      });
      setGUsers(computCnt(gUserArr, value));
    } else {
      // const gUserArr = [];
      for (let i = 0; i < tUsers.length; i++) {
        const element = tUsers[i];
        let token = {};
        if (element.survey_token) {
          token = element.survey_token.find(
            (item) => item.survey_season_id === value
          );
        }
        if (token) {
          gUserArr.push(element);
        }
      }
      // console.log({ gUserArr });
      // console.log({ value });

      setGUsers(computCnt(gUserArr, value));
    }
    // console.log({ value });
    // console.log({ selSeasonInfo });
    // console.log({ gUserArr });
  };

  // value（シーズンID）未指定のときは企業内の全チケットを対象にする。
  // 企業だけを選んだ状態（シーズン未選択）の初期表示と同じ基準。
  // ※ 以前は value が空でも常にシーズン一致で絞っていたため、シーズン未選択のまま
  //   回答差戻しを行うと takeTokenCnt が 0 になり「発行チケット確認」ボタンが
  //   無効化されていた（再読み込みで復帰する見た目のバグ）。
  const computCnt = (gUserArr, value) => {
    gUserArr.map((user) => {
      const targetTokens = value
        ? user.survey_token.filter(
            (tokenInfo) => tokenInfo.survey_season_id === value
          )
        : user.survey_token;
      user.takeTokenCnt = targetTokens.length;
      user.usedTokenCnt = targetTokens.filter(
        (tokenInfo) => tokenInfo.survey_status === 5 //実施済み：5
      ).length;
      user.surveyProgress = user.takeTokenCnt
        ? (user.usedTokenCnt / user.takeTokenCnt) * 100
        : 0;
      return user;
    });
    return gUserArr;
  };

  // const onChangeRole360 = (value) => {
  //   setRole360(value); //選択した設問セットIDを格納
  //   // console.log({ value });
  //   const gUserArr = [];
  //   //360度診断の場合
  //   // console.log({ selSurveySeason });
  //   selSurveySeason.relation_360.map((element) => {
  //     switch (value) {
  //       case 1:
  //         gUserArr.push(tUsers.find((item) => item._id === element.user_id)); //本人のみをFilter
  //         break;

  //       case 2:
  //         element.boss.map((boss) =>
  //           gUserArr.push(tUsers.find((item) => item._id === boss))
  //         ); //上司のみをFilter
  //         break;

  //       case 3:
  //         element.partner.map((partner) =>
  //           gUserArr.push(tUsers.find((item) => item._id === partner))
  //         ); //部下・同僚のみをFilter
  //         // console.log({ gUserArr });
  //         break;

  //       default:
  //         break;
  //     }
  //     // console.log({ gUserArr });
  //   });
  //   setGUsers(gUserArr);
  // };

  //ボタン削除されたのでFuncも削除
  // const surveySendHandler = async (user, surveyCode, e) => {
  //   e.preventDefault();
  //   try {
  //     // console.log({ user });
  //     const sendDate = new Date();
  //     let expire = new Date();
  //     expire = expire.setDate(expire.getDate() + 30);

  //     const data = {
  //       user: user._id,
  //       survey_code: surveyCode,
  //       token_make_date: sendDate,
  //       token_expire: expire,
  //       token_valid: sendDate,
  //       survey_status: 0,
  //       group_code: user.group_code,
  //     };
  //     // console.log({ data });
  //     const res = await Axios.post('/api/surveyToken', data);
  //     if (res.data.success) {
  //       await readDB();
  //       message.success('Tokenを発行しました。');
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  //yyyy/mm/dd hh:mm
  const ymdhms = (tdate) => {
    let date = new Date(tdate);
    //console.log({ date });
    return (
      date.getFullYear() +
      '/' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + date.getDate()).slice(-2) +
      ' ' +
      ('0' + date.getHours()).slice(-2) +
      ':' +
      ('0' + date.getMinutes()).slice(-2)
      // date.getMilliseconds()
    );
  };
  const ymd = (tdate) => {
    let date = new Date(tdate);
    // console.log({ tdate });
    return (
      date.getFullYear() +
      '/' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + date.getDate()).slice(-2)
      // date.getMilliseconds()
    );
  };
  //「チケット発行確認」ボタンを押した時
  const viewTicketHandler = async (user, e) => {
    e.preventDefault();
    // console.log({ user });
    // console.log({ survey });
    try {
      let ut = [];
      user.survey_token.forEach((element) => {
        let element2 = element;
        if (element.survey_status === survey_status_complete) {
          element2.update = ymdhms(element.updatedAt);
          element2.study_end_date = ymdhms(element.updatedAt);
        } else {
          element2.update = surveyStatus[element.survey_status];
        }
        element2.tokenExpire = ymdhms(element.token_expire);
        element2.tokenValid = ymdhms(element.token_valid);
        element2.groupCode = element.group_code;
        let surveyName = '';
        //シーズンIDが存在するならシーズン名を表示
        if (element.survey_season_id) {
          let surveySeasonInfo = surveySeason.find(
            (item) => item._id === element.survey_season_id
          );
          surveyName = surveySeasonInfo.season_name;
          element2.e3_option = surveySeasonInfo.e3_option;
          // console.log({ surveySeasonInfo });
          element2.tName = surveySeasonInfo.t_name;
        } else {
          surveyName = surveyCode[element.survey_code];
        }
        //Question Set Idが存在するならQuestionSet名を表示
        if (element.question_set_id && element.survey_code !== '20210') {
          let surveyInfo = survey.find(
            (item) => item._id === element.survey_id
          );
          // console.log({ surveyInfo });
          surveyName =
            surveyName +
            ' : ' +
            surveyInfo.question_set.find(
              (item) => item._id === element.question_set_id
            ).set_name;
        }
        element2.group_name = user.company;
        element2.company = user.company;
        element2.user_name = user.fullName;
        element2.email = user.email; // 差戻し通知メールの宛先表示・送付用
        element2.emp_no = user.emp_no;
        element2.department = user.department;
        element2.surveyName = surveyName;
        ut.push(element2);
      });
      // 各チケットのレポート「本人ダウンロード回数」を取得して付与する
      try {
        const tokenIds = ut.map((t) => t._id);
        const dlRes = await Axios.post('/api/surveyToken/download-counts', {
          tokenIds,
        });
        if (dlRes.data.success) {
          const counts = dlRes.data.counts || {};
          ut.forEach((t) => {
            t.dlCount = counts[String(t._id)] || 0;
          });
        }
      } catch (e) {
        console.log(e);
      }
      // console.log({ user });
      // console.log({ ut });
      setUserToken(ut);
      setViewModal(true);
    } catch (error) {
      alert('サーベイ情報が読み込めませんでした。');
      console.log(error);
    }
  };

  //チケット発行処理
  const start = async () => {
    try {
      // console.log({ rowKeys });
      message.loading({
        content: 'チケット発行中...',
        key: 'ticket',
        duration: 20,
      });
      const data = [];
      const sendDate = new Date();
      let expire = new Date();
      expire = expire.setDate(expire.getDate() + 60);
      let selSurveyCode = survey.find(
        (element) => element._id === selSurveyId
      ).survey_code;
      rowKeys.selectedRowKeys.forEach((element) => {
        if (selQuestionSetId) {
          //設問セットが存在するなら
          data.push({
            user: element,
            survey_code: selSurveyCode,
            survey_id: selSurveyId,
            question_set_id: selQuestionSetId,
            token_make_date: sendDate,
            token_expire: expire,
            token_valid: sendDate,
            survey_status: 0,
            group_code: selGroupCode,
            survey_season_id: selSurveySeasonId,
          });
        } else {
          //設問セットが存在しないなら
          data.push({
            user: element,
            survey_code: selSurveyCode,
            survey_id: selSurveyId,
            token_make_date: sendDate,
            token_expire: expire,
            token_valid: sendDate,
            survey_status: 0,
            group_code: selGroupCode,
            survey_season_id: selSurveySeasonId,
          });
        }
      });
      // console.log({ data });
      setRowKeys({ selectedRowKeys: [], loading: true });
      const res = await Axios.post('/api/surveyToken/ticket', data);
      if (res.data.success) {
        await readDB();
        setSelGroupCode(null);
        setSelSurveyId(null);
        setSelQuestionSetId(null);
        setQuestionSet([]);
        // setSelSurveySeasonInfo([]);
        setSelGroupInfo([]);
        setRowKeys({
          selectedRowKeys: [],
          loading: false,
        });
        message.success({
          content: 'チケット発行完了',
          key: 'ticket',
          duration: 2,
        });
      }
    } catch (error) {
      console.log(error);
    }
    // setTimeout(() => {
    // }, 1000);
  };

  //結果PDFを見せる：人事評価力診断のみ
  // const viewSurveyResultHandler = async (tokenInfo, e) => {
  //   e.preventDefault();
  //   // console.log({ tokenInfo });
  //   try {
  //     let url = '';
  //     if (tokenInfo.groupCode) {
  //       url = `${config.S3_URL}/${config.S3_ENV}/user/${tokenInfo.groupCode}/${tokenInfo.user}/rcep_${tokenInfo._id}.pdf`;
  //     } else {
  //       url = `${config.S3_URL}/${config.S3_ENV}/user/${tokenInfo.user}/rcep_${tokenInfo._id}.pdf`;
  //     }
  //     window.open(url, '_blank');
  //   } catch (error) {
  //     alert('サーベイ結果確認ができません。');
  //     console.log(error);
  //   }
  // };

  const showConfirm = async (tokenI, type) => {
    confirm({
      title: 'サーベイ結果を生成しますか？',
      content:
        'サーベイ結果を生成し別TabでPDF表示します。このままお待ちください。',
      async onOk() {
        setIsModalVisible(true);
        // return new Promise((resolve, reject) => {
        //   setTimeout(Math.random() > 0 ? resolve : reject, 3000);
        //   ansSendHandler();
        // }).catch(() => console.log('サーベイ結果提出でエラーが発生しました。'));
        // console.log({ tokenI });
        // console.log({ selSurveySeason });
        tokenI.type = type; //1:個人用、2:共有用, 30010:E3-Survey
        tokenI.training_start_date = selSurveySeason.training_start_date;
        tokenI.training_end_date = selSurveySeason.training_end_date;
        tokenI.survey_start_date = selSurveySeason.survey_start_date;
        tokenI.survey_end_date = selSurveySeason.survey_end_date;
        let result = {};
        if (type === 30010) {
          result = await Axios.post(
            '/api/dbModel100/makeReport30010Personal',
            tokenI
          );
        } else if (type == 10010 || type == 90101) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport', tokenI);
          // result.data.success = false;
        } else if (type == 50010 || type == 90501) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport50010', tokenI);
          // result.data.success = false;
          // console.log({ result });
        } else if (type == 50020 || type == 90502) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport50020', tokenI);
          // result.data.success = false;
          // console.log({ result });
        } else if (type == 50030 || type == 90503) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport50030', tokenI);
          // result.data.success = false;
          // console.log({ result });
        } else if (type == 50040) {
          //ソーシャルスタイル診断（コース版90504は未実装）
          result = await Axios.post('/api/dbModel100/makeReport50040', tokenI);
        } else if (type == 60010 || type == 90601) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport60010', tokenI);
          // result.data.success = false;
        }
        // console.log({ result });
        if (result.data.success) {
          // message.success('結果生成が完了しました。マイ・サーベイに戻ります。');
          // props.history.push('/mysurvey');
          // サーバープロキシ経由でPDFを表示（S3 URLを露出しない）
          message.success({
            content: 'ファイル生成完了！',
            key: 'makecsv',
            duration: 2,
          });
          setIsModalVisible(false);
          openReport(result.data.tokenId);
        } else {
          setIsModalVisible(false);
          console.log('結果生成で問題が発生しました。');
          message.error('結果生成で問題が発生しました。');
        }
      },
      async onCancel() {},
    });
  };

  //チケット削除
  // 回答差戻し: 提出済み(survey_status:5)を「一時保存中」へ戻し、対象者が再編集・再提出
  // できるようにする(role 9 専用)。本回答・レポートは保持され、再提出時に更新される。
  const revertAnswerHandler = async (tokenInfo, e) => {
    if (e) e.preventDefault();
    // 通知メール送付の要否 + CC/BCC を選ぶモーダルを開く（実行は executeRevert）。
    // BCC は予約メール画面と同様、既定アドレスを初期表示し画面上で削除・変更できる。
    setRevertTarget(tokenInfo);
    setRevertCc('');
    setRevertBcc(DEFAULT_BCC_EMAIL);
    setRevertNotify(false);
    setRevertConfirmOpen(false);
    setRevertModalOpen(true);
  };

  // 実際の差戻し実行。notify=true なら差戻し通知メールを即時送信（cc/bcc 付き）。
  const executeRevert = async () => {
    const tokenInfo = revertTarget;
    if (!tokenInfo) return;
    setRevertSubmitting(true);
    try {
      const res = await Axios.post(
        `/api/surveyToken/${tokenInfo._id}/revert`,
        { notify: revertNotify, cc: revertCc, bcc: revertBcc }
      );
      if (res.data.success) {
        // モーダル内一覧の該当チケットのステータスを更新
        setUserToken((prev) =>
          prev.map((t) =>
            t._id === tokenInfo._id
              ? {
                  ...t,
                  survey_status: 0,
                  answer_id: null,
                  was_reverted: true,
                  update: surveyStatus[1], // 一時保存中
                }
              : t
          )
        );
        // テーブルのユーザーデータ側の複製も同期
        const revertToken = (users) =>
          users.map((u) =>
            u._id === tokenInfo.user
              ? {
                  ...u,
                  survey_token: u.survey_token.map((t) =>
                    t._id === tokenInfo._id
                      ? {
                          ...t,
                          survey_status: 0,
                          answer_id: null,
                          was_reverted: true,
                        }
                      : t
                  ),
                }
              : u
          );
        // 差戻しで実施済(5)→一時保存中(0)に変わるので発行/実施済カウントを再計算し即時反映。
        setGUsers((prev) =>
          computCnt(revertToken(prev), selSurveySeasonIdFilter)
        );
        setTUsers((prev) => revertToken(prev));
        // 通知メールの結果もあわせて知らせる
        const notifyMsg = revertNotify
          ? res.data.notified
            ? '（通知メールを送付しました）'
            : '（通知メールの送付に失敗しました）'
          : '';
        message.success({
          content: `回答を差し戻しました${notifyMsg}`,
          key: 'revert',
          duration: 3,
        });
        setRevertConfirmOpen(false);
        setRevertModalOpen(false);
        setRevertTarget(null);
      } else {
        message.error(res.data.error || '差戻しに失敗しました');
      }
    } catch (error) {
      console.log(error);
      message.error('差戻しに失敗しました');
    } finally {
      setRevertSubmitting(false);
    }
  };

  const deleteTicketHandler = async (tokenInfo, e) => {
    Modal.confirm({
      title: 'チケットを削除しますか？',
      content: 'この操作は取り消せません。',
      okText: 'はい',
      cancelText: 'いいえ',
      async onOk() {
        try {
          const res = await Axios.delete(
            `/api/surveyToken/ticket/${tokenInfo.user}/${tokenInfo._id}`
          );
          if (res.data.success) {
            // モーダル内のチケット一覧から削除したチケットだけ除外する（画面状態を維持）
            setUserToken((prev) => prev.filter((t) => t._id !== tokenInfo._id));
            // テーブルのユーザーデータからも該当チケットを除外する
            const removeToken = (users) =>
              users.map((u) =>
                u._id === tokenInfo.user
                  ? {
                      ...u,
                      survey_token: u.survey_token.filter(
                        (t) => t._id !== tokenInfo._id
                      ),
                    }
                  : u
              );
            setGUsers((prev) => removeToken(prev));
            setTUsers((prev) => removeToken(prev));
            message.success({
              content: 'チケット削除完了',
              key: 'ticket',
              duration: 2,
            });
          }
        } catch (error) {
          console.log(error);
        }
      },
    });
  };

  //ModalでのOK
  const handleOk = (e) => {
    // console.log(e);
    setViewModal(false);
  };

  const handleCancel = (e) => {
    // console.log(e);
    setViewModal(false);
  };

  const csvDownloadHandler = async (event) => {
    event.preventDefault();
    // console.log({ gUsers });
    try {
      message.loading({
        content: 'データ作成中...',
        key: 'makecsv',
        duration: 20,
      });
      const tempData = {};
      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet('sheet1');
      const worksheet = workbook.getWorksheet('sheet1');
      let columns = [
        { header: 'ID', key: 'user_id' },
        { header: 'eメール', key: 'email' },
        { header: '姓', key: 'lastname' },
        { header: '名', key: 'name' },
        { header: '社員番号', key: 'empNo' },
        { header: 'ロール', key: 'roletext' },
        { header: '会社名', key: 'company' },
        { header: '部署①', key: 'department' },
        { header: '部署②', key: 'department2' },
        { header: '部署③', key: 'department3' },
        { header: '部署④', key: 'department4' },
        { header: '部署⑤', key: 'department5' },
        { header: '役職', key: 'position' },
        { header: '等級', key: 'level_code' },
        { header: '性別', key: 'sex' },
        { header: '生年月日', key: 'birthday' },
        { header: '入社日', key: 'join_company' },
        { header: '雇用携帯', key: 'emp_type' },
        { header: '勤務地', key: 'work_location' },
        { header: '勤務時間制度・職制', key: 'work_time_rule' },
        { header: '勤務時間', key: 'work_time' },
        { header: '入社形態', key: 'join_type' },
        { header: '出向状態', key: 'go_out' },
        { header: '職種', key: 'job_type' },
        { header: 'パスワード変更', key: 'change_password' },
        { header: '初期設定PW', key: 'init_pass' },
      ];
      worksheet.columns = columns;
      // 詳細検索が適用されている場合、画面表示と一致させるためdisplayUsersを対象とする
      const exportUsers = displayUsers;
      // console.log(exportUsers);
      for (let i = 0; i < exportUsers.length; i++) {
        const element = exportUsers[i];
        tempData.user_id = element._id;
        tempData.company = element.company;
        tempData.department = element.department;
        tempData.department2 = element.department2;
        tempData.department3 = element.department3;
        tempData.department4 = element.department4;
        tempData.department5 = element.department5;
        tempData.email = element.email;
        tempData.lastname = element.lastname;
        tempData.name = element.name;
        tempData.empNo = element.emp_no;
        tempData.roletext = element.roleText;
        tempData.position = element.position; //役職
        tempData.level_code = element.level_code; //等級
        switch (element.sex) {
          case 1:
            tempData.sex = '男性';
            break;
          case 2:
            tempData.sex = '女性';
            break;
          case 3:
            tempData.sex = 'その他';
            break;
          case 4:
            tempData.sex = '回答しない';
            break;
          default:
            tempData.sex = '未登録';
            break;
        }
        tempData.birthday = ymd(element.birthday); //生年月日
        tempData.join_company = ymd(element.join_company); //入社日
        tempData.emp_type = element.emp_type; //雇用携帯
        tempData.work_location = element.work_location; //勤務地
        tempData.work_time_rule = element.work_time_rule; //勤務時間制度・職制
        tempData.work_time = element.work_time; //勤務時間
        tempData.join_type = element.join_type; //入社携帯
        tempData.go_out = element.go_out; //出向状態
        tempData.job_type = element.job_type; //職種
        tempData.init_pass = element.init_pass; //初期パスワード
        tempData.change_password = element.change_password; //パスワード変更歴
        worksheet.addRow(tempData);
      }
      const uint8Array = await workbook.xlsx.writeBuffer();
      const blob = new Blob([uint8Array], {
        type: 'application/octet-binary',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      // ファイル名生成：シーズン未選択時はグループ名で代替、それもない場合は'AllUsers'
      const seasonPart =
        selSurveySeason && selSurveySeason.season_name
          ? selSurveySeason.season_name
          : (selGroupInfo && selGroupInfo.group_name) || 'AllUsers';
      if (selQuestionSetId) {
        let selQuestionSetInfo = questionSet.find(
          (item) => item._id === selQuestionSetId
        );
        a.download = `Recurrent_Sruvey_RawData_${seasonPart}_${selQuestionSetInfo.set_name}_${isAnswerd}.xlsx`;
      } else {
        a.download = `Recurrent_Sruvey_RawData_${seasonPart}_${isAnswerd}.xlsx`;
      }
      a.click();
      // ダウンロード後は不要なのでaタグを除去
      a.remove();
      // console.log({ excelData });
      // console.log(excelData.length);
      message.success({
        content: 'ダウンロード完了！',
        key: 'makecsv',
        duration: 2,
      });
    } catch (error) {
      console.log({ error });
      message.error({
        content: 'ダウンロード失敗！',
        key: 'makecsv',
        duration: 2,
      });
    }
  };

  // テーブル強化 PJ Ph.3: メイン一覧テーブルの <Column> → columns 配列。
  // rowSelection（チェックボックス列）があるため reservedWidth で幅を予約。
  // テキスト列はソート + 省略、操作列（チケット/権限/PW/削除）は既存ボタンを維持。
  const rawColumns = [
    ellipsisColumn({
      title: '名前',
      dataIndex: 'fullName',
      key: 'fullName',
      width: 140,
      sorter: textSorter('fullName'),
      // 集計対象外のユーザーは名前の下にバッジ（名前の表示幅は他の行と同じ）
      subline: (record) => (record.inactive ? <InactiveBadge /> : null),
    }),
    ellipsisColumn({
      title: 'メール',
      dataIndex: 'email',
      key: 'email',
      width: 200,
      sorter: textSorter('email'),
    }),
    ellipsisColumn({
      title: '会社',
      dataIndex: 'company',
      key: 'company',
      width: 150,
      sorter: textSorter('company'),
    }),
    ellipsisColumn({
      title: '部署',
      dataIndex: 'department',
      key: 'department',
      width: 130,
      sorter: textSorter('department'),
    }),
    {
      title: 'チケット発行',
      key: 'ticket',
      width: 300,
      sorter: numberSorter('takeTokenCnt'),
      render: (text, record) => (
        <span>
          <Button
            size="small"
            onClick={(e) => viewTicketHandler(record, e)}
            disabled={
              record.role === 0 || record.takeTokenCnt === 0 ? true : false
            }
          >
            発行チケット確認
          </Button>
          <span>
            {record.takeTokenCnt !== 0 &&
            record.takeTokenCnt === record.usedTokenCnt ? (
              <Text mark>
                {' 発行：' +
                  record.takeTokenCnt +
                  ' | 実施済：' +
                  record.usedTokenCnt}
              </Text>
            ) : record.takeTokenCnt !== 0 ? (
              <Text type="danger">
                {' 発行：' +
                  record.takeTokenCnt +
                  ' | 実施済：' +
                  record.usedTokenCnt}
              </Text>
            ) : (
              <Text>
                {' 発行：' +
                  record.takeTokenCnt +
                  ' | 実施済：' +
                  record.usedTokenCnt}
              </Text>
            )}
          </span>
        </span>
      ),
    },
    {
      // 権限付与（ユーザー単件編集 PJ Ph.2 で ボタン 3 個 → Select 1 個に集約。幅 340 → 170）
      // 停止中（role 0）は「復元」のみ。選択肢外の権限（リ・カレント管理者等）はラベル表示のみで非活性。
      title: '権限付与',
      key: 'action',
      width: 170,
      render: (text, record) =>
        record.role === 0 ? (
          <Button
            type="primary"
            size="small"
            onClick={(e) => roleChangeHandler(record._id, 1, record.role, e)}
            disabled={usr.userData.role !== 9 ? true : false}
          >
            復　元
          </Button>
        ) : (
          <Select
            size="small"
            style={{ width: 150 }}
            value={record.role}
            disabled={
              usr.userData.role !== 9 || !ROLE_SELECTABLE.includes(record.role)
            }
            onChange={(value) =>
              roleChangeHandler(record._id, value, record.role)
            }
            options={
              ROLE_SELECTABLE.includes(record.role)
                ? ROLE_SELECT_OPTIONS
                : ROLE_SELECT_OPTIONS.concat([
                    {
                      value: record.role,
                      label: userRole[record.role],
                      disabled: true,
                    },
                  ])
            }
          />
        ),
    },
    // 「編集」列（ユーザー情報編集モーダル）は特権管理者（role 9）にのみ表示する
    ...(usr.userData && usr.userData.role === 9
      ? [
          {
            title: '編集',
            key: 'edit',
            width: 100,
            resizable: false,
            render: (text, record) => (
              <Button
                size="small"
                className="ds-btn-accent"
                disabled={record.role === 0}
                onClick={() => openEditModal(record)}
              >
                情報編集
              </Button>
            ),
          },
        ]
      : []),
    {
      title: 'パスワード',
      key: 'passchange',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            danger
            size="small"
            onClick={(e) => passworChangedHandler(record, e)}
            disabled={record.role === 0 ? true : false}
          >
            初期化
          </Button>
        </span>
      ),
    },
    {
      title: '削除',
      key: 'delete',
      width: 110,
      render: (text, record) => (
        <span>
          <Button
            danger
            size="small"
            onClick={(e) => userDeleteHandler(record._id, record.role, e)}
            disabled={usr.userData.role !== 9 || record.role === 0}
          >
            ユーザ停止
          </Button>
        </span>
      ),
    },
  ];

  const { columns, components, scroll, wrapRef } = useResizableColumns(
    rawColumns,
    { reservedWidth: 32 }
  );

  // テーブル強化 拡大: モーダル（発行チケット確認）内のトークン一覧テーブルにも適用。
  const modalRawColumns = [
    ellipsisColumn({
      title: 'サーベイ名',
      dataIndex: 'surveyName',
      key: 'surveyName',
      width: 240,
      sorter: textSorter('surveyName'),
    }),
    {
      title: '有効期限',
      dataIndex: 'tokenExpire',
      key: 'tokenExpire',
      width: 140,
      sorter: textSorter('tokenExpire'),
    },
    {
      title: '実施日',
      key: 'deleteTicket',
      width: 160,
      render: (text, record) =>
        record.survey_status === survey_status_complete ? (
          <span>{record.update}</span>
        ) : (
          <span>
            <Button
              danger
              size="small"
              onClick={(e) => deleteTicketHandler(record, e)}
              disabled={
                usr.userData.role !== 9 ||
                record.survey_code === '40010' ||
                record.survey_code === '40020' ||
                record.survey_code === '60020'
              }
            >
              {/* 差し戻し履歴があれば「差戻し済：削除」で未実施と区別する */}
              {record.was_reverted ? '差戻し済：削除' : '未実施：削除'}
              <DeleteOutlined />
            </Button>
          </span>
        ),
    },
    // 回答差戻し(role 9 専用): 提出済みを「一時保存中」へ戻して再編集・再提出させる
    {
      title: '差戻し',
      key: 'revert',
      width: 110,
      render: (text, record) =>
        usr.userData.role === 9 &&
        record.survey_status === survey_status_complete ? (
          <Button
            danger
            size="small"
            onClick={(e) => revertAnswerHandler(record, e)}
          >
            回答差戻し
          </Button>
        ) : null,
    },
    {
      title: '結果確認',
      key: 'action',
      width: 200,
      render: (text, record) => (
        <span>
          {record.survey_code === '10010' ||
          record.survey_code === '90101' ||
          record.survey_code === '50010' ||
          record.survey_code === '90501' ||
          record.survey_code === '50020' ||
          record.survey_code === '50030' ||
          record.survey_code === '50040' ||
          record.survey_code === '90502' ||
          record.survey_code === '90503' ||
          record.survey_code === '60010' ||
          record.survey_code === '90601' ? (
            <Button
              type={'primary'}
              size="small"
              onClick={(e) => showConfirm(record, record.survey_code)}
              disabled={record.survey_status === 5 ? false : true}
            >
              サーベイ結果確認 &nbsp;{' '}
              <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
            </Button>
          ) : (record.survey_code === '30010' ||
              record.survey_code === '90301') &&
            record.e3_option ? (
            <Space>
              <Button
                type={'primary'}
                size="small"
                onClick={(e) => showConfirm(record, 30010)}
                disabled={record.survey_status === 5 ? false : true}
              >
                サーベイ結果確認 &nbsp;{' '}
                <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
              </Button>
            </Space>
          ) : (
            <Button size="small" disabled={true}>
              個別結果はありません
            </Button>
          )}
        </span>
      ),
    },
    {
      title: 'DL',
      dataIndex: 'dlCount',
      key: 'dlCount',
      width: 80,
      align: 'center',
      sorter: numberSorter('dlCount'),
      render: (text) => (text ? text : 0),
    },
  ];

  const {
    columns: modalColumns,
    components: modalComponents,
    scroll: modalScroll,
    wrapRef: modalWrapRef,
  } = useResizableColumns(modalRawColumns);

  return (
    <Fragment>
      {/* 大量テーブル（受講者一覧・多列）ページのため fluid（全幅）。
          広幅モニターでデータ密度を確保（デザインシステム「大量テーブル」例外）。 */}
      <PageContainer fluid>
        <div style={{ marginTop: 16, marginBottom: 16 }}>
          ■絞り込み｜企業選択
          <Select
            showSearch
            style={{
              marginBottom: 10,
              marginLeft: 5,
              marginRight: 5,
              width: 200,
            }}
            placeholder="企業選択"
            optionFilterProp="children"
            onChange={onChangeGroup}
            value={selGroupCode}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {groups.map((element) => {
              // console.log({ element });
              return (
                <Option value={element.group_code} key={element._id}>
                  {element.group_name}
                </Option>
              );
            })}
          </Select>
          {selGroupInfo.survey_season && (
            <Fragment>
              サーベイシーズン選択:
              <Select
                showSearch
                style={{
                  marginBottom: 10,
                  marginLeft: 5,
                  marginRight: 5,
                  width: 250,
                }}
                placeholder="シーズン選択"
                optionFilterProp="children"
                onChange={onChangeSeasonFilter}
                value={selSurveySeasonIdFilter}
                defaultValue={selGroupInfo.survey_season[0].season_name}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {filterAccessibleSeasons(selGroupInfo.survey_season, usr.userData).map((element) => {
                  return (
                    <Option value={element._id} key={element._id}>
                      {element.season_name}
                    </Option>
                  );
                })}
              </Select>
              {questionSetFilter.length > 0 && (
                <Select
                  showSearch
                  style={{
                    marginBottom: 10,
                    marginLeft: 5,
                    marginRight: 5,
                    width: 200,
                  }}
                  placeholder="設問セット選択"
                  optionFilterProp="children"
                  onChange={onChangeQuestionFilter}
                  value={selQuestionSetFilterId}
                  defaultValue={questionSetFilter[0].set_name}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {questionSetFilter.map((element) => {
                    return (
                      <Option value={element._id} key={element._id}>
                        {element.set_name}
                      </Option>
                    );
                  })}
                </Select>
              )}
            </Fragment>
          )}
          <Fragment>
            実施選択：
            <Select
              showSearch
              style={{
                marginBottom: 10,
                marginLeft: 5,
                marginRight: 5,
                width: 100,
              }}
              placeholder="対象選択"
              optionFilterProp="items"
              onChange={onChangeAnswer}
              value={isAnswerd}
              disabled={!selSurveySeasonIdFilter}
            >
              <Option value={9} key={9}>
                全員
              </Option>
              <Option value={0} key={0}>
                未回答
              </Option>
              <Option value={5} key={5}>
                回答済み
              </Option>
            </Select>
          </Fragment>
          <Button
            onClick={csvDownloadHandler}
            disabled={displayUsers.length === 0}
          >
            CSVダウンロード
          </Button>
          <Fragment>　対象者：{displayUsers.length}名</Fragment>
          {/* 詳細検索トグル（■絞り込み行の最右端） */}
          <Button
            style={{ marginLeft: 8 }}
            onClick={() => setShowAdvancedSearch((v) => !v)}
          >
            詳細検索 {showAdvancedSearch ? '▲' : '▼'}
          </Button>
          {hasActiveSearch && (
            <StatusBadge tone="processing" style={{ marginLeft: 6 }}>
              条件適用中
            </StatusBadge>
          )}
          <br />
          {/* 詳細検索パネル：名前・メール・権限の絞り込み */}
          {showAdvancedSearch && (
            <div
              style={{
                marginTop: 8,
                padding: 8,
                background: 'var(--grey-10)',
                borderRadius: 4,
              }}
            >
              名前：
              <Input
                style={{ width: 180, marginLeft: 4, marginRight: 12 }}
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                placeholder="名前検索"
                allowClear
              />
              メール：
              <Input
                style={{ width: 220, marginLeft: 4, marginRight: 12 }}
                value={searchEmail}
                onChange={(e) => setSearchEmail(e.target.value)}
                placeholder="メール検索"
                allowClear
              />
              権限付与：
              <Select
                mode="multiple"
                style={{ minWidth: 260, marginLeft: 4, marginRight: 12 }}
                value={searchRoles}
                onChange={(values) => setSearchRoles(values)}
                placeholder="権限選択"
                allowClear
              >
                <Option value={1}>受講者</Option>
                <Option value={7}>シーズン管理者</Option>
                <Option value={3}>企業管理者</Option>
              </Select>
              <Button size="small" onClick={clearAdvancedSearch}>
                クリア
              </Button>
            </div>
          )}
        </div>
        <div ref={wrapRef}>
          <Table
            columns={columns}
            components={components}
            scroll={scroll}
            rowSelection={rowSelection}
            dataSource={pagedUsers}
            size="middle"
            rowKey="_id"
            pagination={false}
          />
        </div>
        {/* 一覧下部: 左端に「＋ User」（role 9・企業選択後のみ）、右端にページネーション（Table 内蔵から外出しして制御） */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 'var(--space-4)',
            marginBottom: 'var(--space-4)',
          }}
        >
          <div>
            {usr.userData.role === 9 && selGroupCode && (
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={openCreateModal}
              >
                User
              </Button>
            )}
          </div>
          <Pagination
            current={pageInfo.current}
            pageSize={pageInfo.pageSize}
            total={displayUsers.length}
            showSizeChanger
            pageSizeOptions={['50', '100', '200', '500']}
            showTotal={(total, range) => `${range[0]}-${range[1]} / ${total}件`}
            onChange={(current, pageSize) => setPageInfo({ current, pageSize })}
          />
        </div>
        <div style={{ marginTop: 16, marginBottom: 16 }}>
          ■チケット発行｜
          {selGroupInfo.survey_season && (
            <Fragment>
              サーベイシーズン選択：
              <Select
                showSearch
                style={{
                  marginBottom: 10,
                  marginLeft: 5,
                  marginRight: 5,
                  width: 400,
                }}
                placeholder="シーズン選択"
                optionFilterProp="children"
                onChange={onChangeSeason}
                value={selSurveySeasonId}
                defaultValue={selGroupInfo.survey_season[0].season_name}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {filterAccessibleSeasons(
                  selGroupInfo.survey_season,
                  usr.userData
                )
                  .filter((element) => {
                    // embeddedデータにsurvey_codeがない場合はsurveySeason stateから参照する
                    const code =
                      element.survey_code ||
                      (surveySeason.find((s) => s._id === element._id) || {})
                        .survey_code;
                    return (
                      code !== '40010' &&
                      code !== '40020' &&
                      code !== '60020'
                    );
                  })
                  .map((element) => {
                    return (
                      <Option value={element._id} key={element._id}>
                        {element.season_name}
                      </Option>
                    );
                  })}
              </Select>
            </Fragment>
          )}
          {questionSet.length > 0 && (
            <Select
              showSearch
              style={{
                marginBottom: 10,
                marginLeft: 5,
                marginRight: 5,
                width: 300,
              }}
              placeholder="設問セット選択"
              optionFilterProp="children"
              onChange={onChangeQuestionSet}
              value={selQuestionSetId}
              defaultValue={questionSet[0].set_name}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {questionSet.map((element) => {
                return (
                  <Option value={element._id} key={element._id}>
                    {element.set_name}
                  </Option>
                );
              })}
            </Select>
          )}
          <Button
            type="primary"
            onClick={start}
            disabled={
              !hasSelected ||
              !selGroupCode ||
              !selSurveyId ||
              selTicketSurveyCode === '40010' ||
              !(usr.userData.role === 9)
            }
            loading={loading}
          >
            チケット発行
          </Button>
          <span style={{ marginLeft: 8 }}>
            {hasSelected ? ` ${selectedRowKeys.length}項目選択中` : ''}
          </span>
        </div>
      </PageContainer>
      {/* ユーザー情報の登録・編集モーダル（role 9 限定。mode で新規登録／編集を切り替える） */}
      <UserFormModal
        open={userModalOpen}
        mode={userModalMode}
        user={editUser}
        groupInfo={selGroupInfo}
        orgTree={orgTree}
        /* ⑦ 発行チケットのサーベイ名組み立て用（一覧の「発行チケット確認」と同じ参照元） */
        surveys={survey}
        surveySeasons={surveySeason}
        onSaved={handleUserSaved}
        onCancel={closeUserModal}
      />
      <div>
        <Modal
          title="チケット確認"
          open={viewModal}
          onOk={handleOk}
          onCancel={handleCancel}
          styles={{ body: { overflowX: 'scroll' } }}
          width={900}
        >
          <div style={{ width: '100%', margin: '0rem auto' }}>
            <div ref={modalWrapRef}>
              <Table
                columns={modalColumns}
                components={modalComponents}
                scroll={modalScroll}
                dataSource={userToken}
                size="middle"
                rowKey="_id"
              />
            </div>
          </div>
        </Modal>
        <Modal
          title="サーベイ結果ファイル生成中..."
          open={isModalVisible}
          okButtonProps={{ disabled: true }}
          cancelButtonProps={{ disabled: true }}
          styles={{ body: { textAlign: 'center' } }}
        >
          <Spin size="large" />
        </Modal>

        {/* 回答差戻し — 通知メール送付の要否 + CC/BCC を選ぶモーダル */}
        <Modal
          title="回答差戻し"
          open={revertModalOpen}
          onCancel={() => setRevertModalOpen(false)}
          maskClosable={false}
          footer={[
            <Button
              key="cancel"
              onClick={() => setRevertModalOpen(false)}
              disabled={revertSubmitting}
            >
              差戻しキャンセル
            </Button>,
            <Button
              key="no-notify"
              danger
              onClick={() => {
                setRevertNotify(false);
                setRevertConfirmOpen(true);
              }}
              disabled={revertSubmitting}
            >
              通知せずに差戻す
            </Button>,
            <Button
              key="notify"
              type="primary"
              onClick={() => {
                setRevertNotify(true);
                setRevertConfirmOpen(true);
              }}
              disabled={revertSubmitting}
            >
              通知送付して差戻す
            </Button>,
          ]}
        >
          <p style={{ marginBottom: 12 }}>
            差し戻した対象者へ、通知を送付します。
          </p>
          {/* 対象者アカウント情報（入力欄と誤認されないよう非活性風グレー） */}
          <div style={{ marginBottom: 4, fontWeight: 'bold' }}>対象者</div>
          <div
            style={{
              border: '1px solid #d9d9d9',
              borderRadius: 6,
              padding: '6px 10px',
              background: '#f5f5f5',
              color: '#595959',
              cursor: 'default',
              marginBottom: 16,
            }}
          >
            {revertTarget?.user_name || '(氏名なし)'}
            <span style={{ marginLeft: 8 }}>{revertTarget?.email || ''}</span>
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={{ marginBottom: 4, fontWeight: 'bold' }}>CC</div>
            <Input
              placeholder="メールアドレスを入力"
              value={revertCc}
              onChange={(e) => setRevertCc(e.target.value)}
              allowClear
            />
            <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
              ＊複数の場合はメールアドレスを「;」区切りで入力してください
            </div>
          </div>
          <div>
            <div style={{ marginBottom: 4, fontWeight: 'bold' }}>BCC</div>
            <Input
              placeholder="メールアドレスを入力"
              value={revertBcc}
              onChange={(e) => setRevertBcc(e.target.value)}
              allowClear
            />
            <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
              ＊複数の場合はメールアドレスを「;」区切りで入力してください
            </div>
          </div>
        </Modal>

        {/* 差戻し最終確認（通知メール送付の有無で文言が変わる） */}
        <Modal
          title="差戻しの確認"
          open={revertConfirmOpen}
          onOk={executeRevert}
          onCancel={() => setRevertConfirmOpen(false)}
          okText="OK"
          cancelText="キャンセル"
          confirmLoading={revertSubmitting}
          maskClosable={false}
        >
          <p style={{ marginBottom: 12 }}>
            {revertNotify ? (
              <>
                下記の対象者の回答を差戻し、
                <span style={{ color: '#d4380d', fontWeight: 'bold' }}>
                  その旨をメールで通知します。
                </span>
              </>
            ) : (
              <>
                下記の対象者に
                <span style={{ color: '#d4380d', fontWeight: 'bold' }}>
                  通知メールを送付せず
                </span>
                差戻します。
              </>
            )}
          </p>
          <div
            style={{
              border: '1px solid #d9d9d9',
              borderRadius: 6,
              padding: '6px 10px',
              background: '#f5f5f5',
              color: '#595959',
              cursor: 'default',
            }}
          >
            {revertTarget?.user_name || '(氏名なし)'}
            <span style={{ marginLeft: 8 }}>{revertTarget?.email || ''}</span>
          </div>
        </Modal>
      </div>
    </Fragment>
  );
}

export default RespondentMgrPage;
